<template>
  <div>
    <div class="expire-error_section1">
      <img src="../../../assets/warning-circle.svg" />
      <span class="heading-4 expire-error__margin">{{ $t("visits.expire.title") }}</span>
      <span class="expire-error_sub-title">{{ $t("visits.expire.subtitle") }}</span>
      <div class="expire-error_divider"></div>
      <span class="expire-error_sub-title">{{ $t("visits.expire.subtitle2") }}</span>
    </div>
    <div class="expire-error_section2">
      <OutlinedButton
        :text="$t('visits.expire.button')"
        size="large"
        additionalClassName="outlined-btn__blue"
        :fullWidth="true"
        @onClick="toVisitCenter"
      />
    </div>
  </div>
</template>
<script>
import OutlinedButton from "@/components/uikit/OutlinedButton";

export default {
  name: "ExpireError",
  components: {
    OutlinedButton,
  },
  methods: {
    async toVisitCenter() {
      await this.$router.push("/patient/visits/upcoming");
    },
  },
};
</script>
